<template>
<div ref="subGlobal" class="global-main global-shadow">
  <div class='global-panel' v-loading.body="loading.main">
  正在跳转，请稍后
  </div>
</div>
</template>

<script>
export default {
  name: 'DispatchHome',
  data () {
    return {
      // 遮罩
      loading: {main: false},
      // 可见
      visible: {}
    }
  },
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';

    if(self!=top){
      // 作为子页面打开的
      window.parent.postMessage({ // 传递给父页面单次操作完毕
        act: 'refreshFrame'
      }, '*');

    } else {
      // 作为正常页面打开
      vm.$router.push({path: '/SystemHome'});
    }
  },
  methods: {

  }
}
</script>

<style>
  .global-main {
    padding: 5px 0;
    position: relative;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/app/DispatchHome.vue